import { styled } from "@mui/material";
import { TimePicker } from "@mui/x-date-pickers";

export const StyledFormikTimePicker = {
    Picker: styled(TimePicker)(({ theme }) => ({
    marginTop: 0,
    marginBottom: 0,
  }))
}